import { render, staticRenderFns } from "./ChatMessage.vue?vue&type=template&id=1a779cc1&scoped=true&"
import script from "./ChatMessage.vue?vue&type=script&lang=js&"
export * from "./ChatMessage.vue?vue&type=script&lang=js&"
import style0 from "./ChatMessage.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ChatMessage.vue?vue&type=style&index=1&id=1a779cc1&lang=scss&scoped=true&"
import style2 from "./ChatMessage.vue?vue&type=style&index=2&id=1a779cc1&scoped=true&lang=css&"
import style3 from "./ChatMessage.vue?vue&type=style&index=3&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a779cc1",
  null
  
)

export default component.exports